import {
	CreateOperatorRequest,
	UpdateOperatorRequest,
} from '@/modules/manage-operator/types'
import useMutationCreateOperator from '../../api/hooks/useMutationCreateOperator'
import OperatorForm from '@/modules/manage-operator/components/OperatorForm'

export const AdminOperatorForm = () => {
	const { mutateAsync: mutateCreateOperator } = useMutationCreateOperator()

	const handleSubmit = (
		data: CreateOperatorRequest | UpdateOperatorRequest,
	) => {
		return mutateCreateOperator(data as CreateOperatorRequest)
	}

	return <OperatorForm handleSubmit={handleSubmit} />
}
